import React, { useState } from "react";
import { TbChevronDown } from "react-icons/tb";
import { createClient } from "@supabase/supabase-js";

// Initialize Supabase client
const supabaseUrl = 'https://eslwrhlcneebvehsijvv.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVzbHdyaGxjbmVlYnZlaHNpanZ2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk1NTU0NDQsImV4cCI6MjA3NTEzMTQ0NH0.YJz-mWn_TMYnViuucOuq1ZXWy0bXESoFl0jmvfo3J1I';
const supabase = createClient(supabaseUrl, supabaseKey);

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    inquiryType: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ success: null, message: '' });

  const inquiryTypes = [
    'Schedule a Property Tour',
    'Request Property Information',
    'Speak with a Realtor',
    'Other Questions'
  ];

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ success: null, message: '' });

    try {
      const { error } = await supabase
        .from('inquiries')
        .insert([{
          first_name: formData.firstName,
          last_name: formData.lastName,
          email: formData.email,
          phone: formData.phone,
          inquiry_type: formData.inquiryType,
          message: formData.message,
          created_at: new Date().toISOString()
        }]);

      if (error) throw error;

      setSubmitStatus({ 
        success: true, 
        message: 'Thank you for your inquiry! We will get back to you soon.' 
      });
      
      // Reset form
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        inquiryType: '',
        message: ''
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus({ 
        success: false, 
        message: 'There was an error submitting your form. Please try again later.' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="bg-white py-12 md:py-16 lg:py-20 font-poppins">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 xl:gap-16">
          {/* Left: Form */}
          <div className="w-full lg:w-1/2">
            <div className="max-w-2xl mx-auto">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-gray-900">
                Connect With Our Real Estate Experts
              </h1>
              <p className="text-gray-600 mb-8 text-base sm:text-lg">
                Whether you're buying, selling, or renting, our team is here to guide you through every step of your real estate journey.
              </p>

              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Name fields */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                  <div>
                    <label 
                      className="block text-sm font-medium text-gray-700 mb-1.5" 
                      htmlFor="firstName"
                    >
                      First Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="firstName"
                      type="text"
                      required
                      value={formData.firstName}
                      onChange={handleChange}
                      placeholder="Bluepeak"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label 
                      className="block text-sm font-medium text-gray-700 mb-1.5" 
                      htmlFor="lastName"
                    >
                      Last Name
                    </label>
                    <input
                      id="lastName"
                      type="text"
                      value={formData.lastName}
                      onChange={handleChange}
                      placeholder="realty"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                </div>

                {/* Email and Phone */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                  <div>
                    <label 
                      className="block text-sm font-medium text-gray-700 mb-1.5" 
                      htmlFor="email"
                    >
                      Email Address <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="bluepeakrealty99@gmail.com"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label 
                      className="block text-sm font-medium text-gray-700 mb-1.5" 
                      htmlFor="phone"
                    >
                      Phone Number <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="phone"
                      type="tel"
                      required
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+91 7016937139"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                </div>

                {/* Inquiry Type */}
                <div>
                  <label 
                    className="block text-sm font-medium text-gray-700 mb-1.5" 
                    htmlFor="inquiryType"
                  >
                    Inquiry Type <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <select
                      id="inquiryType"
                      required
                      value={formData.inquiryType}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-lg px-4 py-2.5 pr-10 text-base appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white cursor-pointer"
                    >
                      <option value="" disabled>How can we assist you today?</option>
                      {inquiryTypes.map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <TbChevronDown className="text-gray-500" />
                    </div>
                  </div>
                </div>

                {/* Message */}
                <div>
                  <label 
                    className="block text-sm font-medium text-gray-700 mb-1.5" 
                    htmlFor="message"
                  >
                    Message <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    rows={5}
                    required
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us about your real estate needs..."
                    className="w-full border border-gray-300 rounded-lg px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                  />
                </div>

                {/* Submit Button and Status Message */}
                <div className="space-y-4 pt-2">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`w-full sm:w-auto bg-blue-700 hover:bg-blue-800 text-white font-medium py-2.5 px-8 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                      isSubmitting ? 'opacity-70 cursor-not-allowed' : ''
                    }`}
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit Inquiry'}
                  </button>
                  
                  {submitStatus.message && (
                    <div className={`p-3 rounded-lg text-sm ${
                      submitStatus.success ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'
                    }`}>
                      {submitStatus.message}
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>

          {/* Right: Image */}
          <div className="w-full lg:w-1/2 flex items-center">
            <div className="relative w-full h-full min-h-[240px] lg:min-h-[240px] rounded-2xl overflow-hidden shadow-xl">
              <img
                src="assets/images/inquiryimage.jpg"
                alt="Family sitting together in a modern living room"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
